<template>
	<div class="zhongContainer">
		
	<div class="section">
      <!-- 导航 -->
      <div class="navBar">
        <img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
        <ul class="navBarItem">
          <!-- <li class="busiz-active-sel">
            <router-link exact to="/" tag="a">首页</router-link>
          </li> -->
          <li>
            <router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
          </li>
		  <el-dropdown>
            <li class="brandLi">
              <router-link exact to="/huaiBrand" style="font-size: 1em" tag="a">兰树品牌</router-link>
            </li>
            <el-dropdown-menu class="elDropdown" exact slot="dropdown"
              style="background: rgb(236, 245, 255) !important">
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/huaiBrand" tag="a">
                    淮树</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/brand" tag="a">心清堂
                  </router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/shuiBrand" tag="a">
                    水姻缘</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/yiBrand" tag="a">
                    一清堂</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/zhongBrand" tag="a"><span>Dr.CHUNG<span
						style="vertical-align: super;">+</span></span></router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/lanshuBrand"
                    tag="a">兰树</router-link>
                </li>
              </el-dropdown-item>
			  <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/zbqfBrand"
                    tag="a">植本清方</router-link>
                </li>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
		  <li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
		  <li>
            <router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
          </li>
		  <li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
          
          <li>
            <router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
          </li>
         
          <li>
            <router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
          </li>
        </ul>
      </div>

    </div>
	
	<div class="topImg">
        <img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_10-03-17_31438.png" alt="">
    </div>

	<div class="daohang">
		<span class="home" style="display: flex;" @click="goback()">Dr.CHUNG<span style="margin-top: -0.4vh;">+</span></span>
		<img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-21_10-59-42_87281.png" alt="">
		<span class="series">{{ detail.name1 }}</span>
	</div>

    <div class="content">

        <div class="series-name">
            <div class="name-left">
                <div class="pic">
                    <img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_13-56-43_61808.png" alt="" width="100%">
                </div>
                <div class="title"><span>Dr.CHUNG<span
					style="vertical-align: super;">+</span></span>{{ detail.name }}</div>
                <div class="en-title">{{ detail.en_name }}</div>
                <div class="detail"><span>特点</span> {{ detail.trait }} <br/>
                    <span>功效</span> {{ detail.effect }}
                </div>
                <div class="box">
                    {{ detail.msg }}
                </div>
            </div>
            <div class="name-right">
                <img :src="detail.pic" alt="" width="100%">
            </div>
        </div>

        <div class="series-goods">
            <!-- <div v-for="(item,index) in 7" :key="index"> -->
                <div class="box" v-for="(item,index) in detail.goodsList" :key="index" :style="dynamicStyle">
					<div class="priceNum">{{item.priceNum}}</div>
                    <div class="number">{{ item.number }}</div>
                    <div class="name">{{ item.name }}</div>
                    <div class="img">
                        <img :src="item.pic" alt="" width="100%">
                    </div>
                </div>
            <!-- </div> -->

        </div>
        <div style="width: 100%;height: 300px;">

        </div>

    </div>
	
			
			
			
			<div class="section pageBox6">
				<div class="pageBoxOut2">
				<!-- 底部 -->
				<div class="footerBox">
					<div class="footerBoxHeader">
							<div class="footerBoxHeaderLeft">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树公众号</span>
							</div>
							<div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
								<span class="codeText">兰树云小程序</span>
							</div>
							
							<!-- <div class="footerBoxHeaderRight">
								<img class="codeImg" src="../assets/code.png" alt="">
								<span class="codeText">兰树客服(QQ)</span>
							</div> -->
					
					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank" href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a></li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a></li>
						<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG<span
							style="vertical-align: super;">+</span></span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>
							<div class="footerInfoBox">
								<div class="emailBox">邮箱:  postermaster@lasur.com</div>
								<div class="phoneBox">电话:  0571-89025888</div>
								<div class="addressBox">地址:  浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
							</div>
										
					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> | 
							<img style="width: 16px;" src="../assets/plice.png"/>&nbsp;<a target="_blank"  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备 33052102000740号</a>
						</div>
					</div>
					</div>
				</div>
			</div>
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				detail: {},
				id:0,
			}
		},
		computed: {
			dynamicStyle() {
				return this.id === 1 || this.id === 2 ? { width: '25%' } : { width: '33%' };
			}
		},

        created() {
			window.scrollTo(0, 0);
			this.id= this.$route.query.brandId;
            let index = this.$route.query.brandId;
			if(index == 1){
                this.detail = {
                    name:'「凤凰草润舒系列」',
					name1:'凤凰草润舒系列',
                    en_name:'PHOENIX GRASS SERIES',
                    trait:' 呵护肌肤屏障,维稳肌肤。',
                    effect:' 深澈养护,温和维稳,提高肌肤耐受能力,强韧肌底。',
                    msg:'本系列适用中干性肌肤',
                    pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_16-23-57_41210.jpg',
                    goodsList:[
                        {
                            name:"凤凰草润舒洁面乳",
                            number:'¥128.00 ｜ 100g',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_16-37-51_51483.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-27-55_18369.png'
                        },
                        {
                            name:"凤凰草润舒调理水",
                            number:'¥198.00 ｜ 100ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-17-03_37298.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-26-18_4147.png'
                        },
                        {
                            name:"凤凰草润舒乳液",
                            number:'¥238.00 ｜ 40ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-17-24_98316.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-29-07_81945.png'
                        },
                        {
                            name:"凤凰草润舒面膜",
                            number:'¥228.00 ｜ 25mlx7片',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-17-43_73421.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-28-33_39304.png'
                        },
                        {
                            name:"凤凰草润舒防护乳",
                            number:'¥198.00 ｜ 40ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-18-06_67205.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-27-24_90431.png'
                        },
                        {
                            name:"凤凰草润舒乳霜",
                            number:'¥298.00 ｜ 50g',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-18-33_12498.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-29-39_59433.png'
                        },
                        {
                            name:"凤凰草润舒冻干粉",
                            number:'¥628.00 ｜ 100mgx7对',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-18-54_87597.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-26-53_52477.png'
                        },

                    ]
                }
            }else if(index == 2){
                this.detail = {
                    name:'「金盏花清透系列」',
					name1:'金盏花清透系列',
                    en_name:'CALENDULA OFFICINALIS CLARIFYINGSERIES',
                    trait:'  清透洁净，细腻肌肤。',
                    effect:'  净透爽肤,油水平衡;减少“危”肌，平滑嫩肤。',
                    msg:'本系列适用油性肌肤',
                    pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_14-21-50_39138.png',
                    goodsList:[
                        {
                            name:"金盏花清透洁面露",
                            number:'¥128.00 ｜ 100ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-43-30_83516.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-39-54_83794.png'
                        },
                        {
                            name:"金盏花清透调理水",
                            number:'¥198.00 ｜ 100ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-43-48_88223.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-40-33_18790.png'
                        },
                        {
                            name:"金盏花清透凝露",
                            number:'¥238.00 ｜ 40ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-44-08_1347.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-41-38_28765.png'
                        },
                        {
                            name:"金盏花清透面膜",
                            number:'¥228.00 ｜ 25mlx7片',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-18_17-44-30_24245.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-42-11_27832.png'
                        },
                        

                    ]
                }
            }else if(index == 3){
				this.detail = {
                    name:'「蓝颜系列」',
					name1:'蓝颜系列',
                    en_name:'BLUE SERIES',
                    trait:'  甄选植物精萃,根据个人肌肤，精准搭配,量肤定制。',
                    effect:'   赋能呵护肌肤，愈颜复新。',
                    msg:'本系列适用所有肌肤',
                    pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_14-43-10_62875.jpg',
                    goodsList:[
                        {
                            name:"丹皮酚肌底精华液",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-23-52_25961.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-08-39_26582.png'
                        },
                        {
                            name:"红没药醇肌底精华液",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-23-39_31849.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-09-36_33411.png'
                        },
                        {
                            name:"积雪草肌底精华液",
                            number:'¥298.00 ｜ 50ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-23-27_70524.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-13-18_53515.png'
                        },
                        {
                            name:"玻色因肌底精华液",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-23-02_62063.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-08-05_94809.png'
                        },

						{
                            name:"烟酰胺肌底精华液",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-22-29_92637.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-13-52_79417.png'
                        },
                        {
                            name:"β-葡聚糖眼肌底精华液",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-22-02_45003.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-06-43_32343.png'
                        },
                        {
                            name:"肌源莹润眼霜",
                            number:'¥268.00 ｜ 30g',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-21-10_38541.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-12-48_56757.png'
                        },
                        {
                            name:"肌源莹润眼精华乳",
                            number:'¥268.00 ｜ 30ml',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-20-15_88380.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-11-45_23150.png'
                        },
                        {
                            name:"肌源莹润眼膜",
                            number:'¥268.00 ｜ 6mlx10片',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-21-26_55289.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-12-19_25805.png'
                        },

                    ]
                }
			}else if(index == 4){
				this.detail = {
                    name:'「套盒系列」',
					name1:'套盒系列',
                    en_name:'DOCTOR ZHONG SET BOX SERIES',
                    trait:'   包容性强，性价比高。',
                    effect:'    天然植萃精华,焕新肌肤。',
                    msg:'本系列适用所有肌肤',
                    pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_14-22-56_84875.png',
                    goodsList:[
                        {
                            name:"平衡润舒套",
                            number:'Balancing & Moisturizing Set',
							priceNum:'¥1200.00 ｜ 7件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-36-13_42854.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-59-56_97730.png'
                        },
                        {
                            name:"平衡莹靓套",
                            number:'Balancing & Brightening Set',
							priceNum:'¥600.00 ｜ 3件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-35-57_94489.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_16-00-27_42607.png'
                        },
                        {
                            name:"平衡净肤套 ",
                            number:'Balancing & Purifying Set',
							priceNum:'¥1200.00 ｜ 7件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-35-25_12607.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-59-25_1451.png'
                        },
                        {
                            name:"平衡安肤套",
                            number:'Balancing & Comforting Set',
							priceNum:'¥1200.00 ｜ 7件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-39-52_60098.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-58-54_15803.png'
                        },

						{
                            name:"肌源焕采眼部套",
                            number:'Regenerating Radiance Eye set',
							priceNum:'¥1800.00 ｜ 5件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-39-23_70564.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-57-55_40960.png'
                        },
                        {
                            name:"净澈套",
                            number:'Pore Cleansing Set',
							priceNum:'¥900.00 ｜ 5件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-36-29_97220.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-58-28_80771.png'
                        },
                        {
                            name:"贝龄套",
                            number:'Beiling Essence',
							priceNum:'¥2400.00 ｜ 3件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-40-39_23049.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-55-48_56558.png'
                        },
                        {
                            name:"时光凝润套",
                            number:'The Time Reset Set',
							priceNum:'¥1900.00 ｜ 2件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-40-25_29832.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_16-20-30_12997.png'
                        },
                        {
                            name:"百日焕颜套",
                            number:'Hundred-Day Radiant Suit',
							priceNum:'¥2600.00 ｜ 2件套',
                            // pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-19_09-40-05_63108.png'
							pic:'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2024-10-22_15-55-13_88900.png'
                        },

                    ]
                }
			}
            
        },
		methods:{

			goback(){
				this.$router.go(-1)
			},
			enterHome(){
				this.$router.push({ path: '/' });

			}
			
		}
	}
</script>

<style scoped>

/* img{
	width: 100%;
	height: 100%;
} */
		.zhongContainer{
			margin: 0;
			padding: 0;
			position: relative;
		}
		
		.pageBoxOut2{
			width:90%;
			height: 100%;
			justify-content: center;
			display: flex;
			flex-direction: column;
			align-items:center;
			margin: 0 auto;
			box-sizing: border-box;
		}
		
		/* 导航 */
		
		/* 下拉菜单栏 选中 */	
		.elDropdown_active{
			background-color:#FFFFFF !important;
			color:#000000 !important;
		}
		.navBar{
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			background: #FFFFFF;
			/* border-bottom:1px solid rgba(255,255,255,0.2); */
			z-index: 999;
		}
		
		.router-link-active {
		   background-color:#0F3F93 !important; 
		   color: #FFFFFF !important;
		  }
		
		.navLogo{
			width: 10%;
			margin-left: 5em;
			cursor: pointer;
		}
		
		.navBarItem{
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
		}
		
		
		.navBarItem li{
			/* list-style: none;
			padding: 1.5em 2.5em 1.5em 2.5em;
			float: left; */
			list-style: none;
			/* padding: 25px 40px 25px 40px; */
			float: left;
			/* margin-left: 2em; */
		}
		
		.brandLi a{
			text-decoration: none;
			font-size:0.875em;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #222222;
			line-height: 20px;
			padding-top:1.6em !important;
			padding-bottom: 1.6em !important;
			padding-left: 2em;
			padding-right: 2em;	
		}
		
		.navBarItem li a{
			text-decoration: none;
			font-size:0.875em;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #222222;
			line-height: 20px;
			padding-top:1.4em;
			padding-bottom: 1.4em;
			padding-left: 1.4rem;
			padding-right: 1.4rem;
		}
		
		/* .elDropdown{
			margin-left: -7.5em;
			margin-top: -1em;
		} */
		
		.elDropdown a {
			color: #111111;
			text-decoration: none;
		}
		
		.el-dropdown {
		    vertical-align: top;
		  }
		  .el-dropdown + .el-dropdown {
		    margin-left: 15px;
		  }
		  .el-icon-arrow-down {
		    font-size: 12px;
		  }
		  
		  .el-dropdown-link {
		    cursor: pointer;
		  }
		  .el-icon-arrow-down {
		    font-size: 12px;
		  }
		  
	

		  /* 首图 */
.topImg {
  /* margin-top: 66px; */
	width: 100%;
 	background-color: #fff;
	transition-property: all;
  	text-align: center;
}

.topImg img {
  width: 100%;
  height: 100%;
	/* height: 462px; */
}


.content{
    min-height: 1000px;
}

.series-name{
    display: flex;
    flex-direction: row;
    position: relative;
    height: 75vh;
}

.name-left{
    position: absolute;
    left: 11.35vw;
    top: 23vh;
}

.name-left .pic{
	width: 12vw;
}

.name-left .title{
    height: 2.3vh;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 1.3vw;
    color: #1D439C;
    line-height: 2.3vh;

    margin-top: 13vh;
}
.name-left .en-title{
height: 1.2vh;
font-family: Source Han Sans SC;
font-weight: 400;
font-size: 0.833vw;
color: #033489;
line-height: 4.7vh;
margin-top: 1.5vh;
}

.name-left  .detail{
    
    height: 5.5vh;
    font-family: SourceHanSansSC-Normal;
    font-weight: 400;
    font-size: 0.833vw;
    color: #727171;
    line-height: 3.8vh;
    margin-top: 5vh;
}

.name-left .detail span{
    color: #1D439C;
}

.name-left .box{
    width: 9.583vw;
height: 3.2vh;
	margin-top: 4.2vh;
	border: 0.05vw solid #9D9C9C;
	text-align: center;
	line-height: 3.2vh;
	color: #727171;
	font-size: 0.833vw;
}

.name-right{
    position: absolute;
    top: 11.2vh;
    right: 13.7vw;

	width: 23.125vw;
}

.series-goods{
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

}

.series-goods .box{
    /* width: 25%; */
    display: flex;
	flex-direction: column-reverse;
	align-items: center;
    text-align: center;
    margin-top: 16.7vh;
}

.series-goods .box .number{
height: 1.6vh;
font-family: Source Han Sans SC;
font-weight: 400;
font-size: 0.833vw;
color: #727171;
line-height: 3.8vh;
margin-top: 1vh;

}
.series-goods .box .priceNum{
height: 1.6vh;
font-family: Source Han Sans SC;
font-weight: 400;
font-size: 0.833vw;
color: #727171;
line-height: 3.8vh;
margin-top: 1vh;

}

.series-goods .box .name{
height: 1.6vh;
font-family: Source Han Sans SC;
font-weight: 400;
font-size: 0.833vw;
color: #727171;
line-height: 3.8vh;
margin-top: 3vh;
}

.series-goods .box .img{
	width: 14vw;
}



.daohang{
	margin-left: 10.42vw;
	margin-top: 4vh;
	display: flex;
	align-items: center;
	
}
.daohang .home{
	font-size: 0.833vw;
	color: #666;
	height: 2vh;
	line-height: 2vh;
	cursor: pointer;
}

.daohang .addNumHome{
	font-size: 0.633vw;
	color: #666;
	height:2.5vh;
	line-height: 2vh;
	cursor: pointer;
	display: flex;
}

.daohang img{
	width: 1.04vw;
	height: 2vh;
}
.daohang .series{
	font-size: 0.9375vw;
	color: #222;
	height: 2vh;
	line-height: 2vh;
}




		
		
		
		/* pageBox2 */

		
		.pageBox6{
			height: 653px;
		  	width: 100%;
			background-color:#023591;
		}
		
		/* footer */
		 .footerBox{
		 	width:90%;
		 	/* height: 287px; */
		 	background:#023591;
		 	/* position:absolute;
		 	bottom:0; */
			margin: 0 auto;
		 	flex-direction: column;
		 	z-index: 999;
		 }
		 
		  
		 .footerBoxHeader{
		 	margin: 0 auto;
		 	display: flex;
		 	flex-direction: row;
		 	align-items: center;
		 	justify-content: center;
		 	margin-top: 2%;
		 }
		 
		 .footerBoxHeaderLeft{
		 	display: flex;
		 	flex-direction: column;
		 	align-items: center;
		 }
		 
		 .footerBoxHeaderRight{
		 	display: flex;
		 	flex-direction: column;
		 	align-items: center;
			margin-left: 5em;
		 }
		 
		 .footerBoxHeaderMiddle{
		 	display: flex;
		 	flex-direction: column;
		 	align-items: center;
		 }
		 
		 .codeImg{
		 	width:100%;
		 }
		 
		 .codeText{	
		 font-size: 0.88em;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color: #fff;
		 line-height: 20px;
		 margin-top: 0.5rem;
		 }
		 
		 
		 
		 .footerLine{
		 	width: 79%;
		 	height: 1px;
		 	display: flex;
		 	background: #fff;
		 	opacity: 0.1;
		 	margin: 0 auto;
		 	align-items:center;
		 	margin-top: 1em;
		 }
		 
		 
		 
		 .footerInfoBox{
			 display: flex;
			 flex-direction: column;
			 align-items: center;
			 margin-top: 2rem;
		 }
		 
		 .emailBox{
			 font-size:0.875rem;
			 font-family: PingFangSC-Regular, PingFang SC;
			 font-weight: 400;
			 color: #fff;
			 line-height: 20px;
		 }
		 
		 
		 .phoneBox{
			 font-size:0.875rem;
			 font-family: PingFangSC-Regular, PingFang SC;
			 font-weight: 400;
			 color:#fff;
			 line-height: 20px;
			 margin-top: 0.5rem;
		 }
		 
		 .addressBox{
			font-size:0.875rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #fff;
			line-height: 20px;
			margin-top: 0.5rem;
		 }
		 
		 
		 .footerBoxBottom{
		 	display: flex;
		 	margin: 0 auto;
		 	align-items: center;
		 	flex-direction: row;
		 	justify-content: center;
		 	margin-top: 1rem;
		 }
		 
		 
		 
		 .footerLeft{
		 font-size:0.875em;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color:#fff;
		 line-height: 24px;
		 }
		 
		 .footerLeft a{
		 	text-decoration: none;
		 	cursor: pointer;
		 	color: #fff;
		 }
		 
		 .footerLeft a:hover{
		 	color:#003F98;
		 }
		 
		 .footerMiddle{
		 	display: flex;
		 	flex-direction: column;
		 	margin-left: 1em;
		 }
		 
		 .footerMiddle span{
		 font-size: 0.875em;
		 font-family: PingFangSC-Regular, PingFang SC;
		 font-weight: 400;
		 color:#fff;
		 line-height: 24px;
		 }
		 
		 .footerRight{
		 	display: flex;
		 	flex-direction: column;
		 	margin-left: 1em;
		 }
		 
		 .footerRight li a{
		 	text-decoration: none;
		 	font-size:0.875em;
		 	font-family: PingFangSC-Regular, PingFang SC;
		 	font-weight: 400;
		 	color:#fff;
		 	line-height: 28px;
		 }
		 
		 .footerRight li{
		 	list-style: none;
		 }
		 
		 .footerLast{
		 	display: flex;
		 	flex-direction: column;
		 	margin-left: 1em;
		 }
		 
		 .lastHeader{
		 	display: flex;
		 	flex-direction: row;
		 	font-size:0.875em;
		 	font-family: PingFangSC-Regular, PingFang SC;
		 	font-weight: 400;
		 	color: #fff;
		 	line-height: 28px;
			margin-left: 2em;
		 }
		 
		 .lastHeader li a {
		 	text-decoration: none;
		 	font-size:0.875rm;
		 	font-family: PingFangSC-Regular, PingFang SC;
		 	font-weight: 400;
		 	color: #fff;
		 	line-height: 28px;
		 }
		 
		 .lastHeader li {
		 	list-style: none;
		 }
		 
		 .footerLast span{
		 	font-size:0.875em;
		 	font-family: PingFangSC-Regular, PingFang SC;
		 	font-weight: 400;
		 	color: #fff;
		 }
		 
		 .footerMainBox{
			 display: flex;
			 flex-direction: row;
			 margin: 0 auto;
			 align-items: center;
			 flex-direction: row;
			 justify-content: center;
			 margin-top: 2em;
		 }
		 
		 
		 
		.footerShop{
			list-style:none;
		}
		
		 .footerShop a{
			 text-decoration: none;
			 font-size:0.875rem;
			 font-family: PingFangSC-Regular, PingFang SC;
			 font-weight: 400;
			 color: #fff;
			 padding-left: 3em;
			 line-height: 28px;
			 cursor: pointer;
		 }
		
</style>



// WEBPACK FOOTER //
// src/components/zhongList.vue